import React, { useEffect } from 'react';
import { Alert, Snackbar } from '@mui/material';
import { useAlert } from '../contexts/AlertContext';

const AlertComponent: React.FC = () => {
    const { alertState, hideAlert } = useAlert();
    useEffect(() => {
    }, [alertState])
    return (
        <Snackbar
            open={alertState.open}
            autoHideDuration={2000}
            onClose={hideAlert}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
            <Alert
                onClose={hideAlert}
                severity={alertState.severity}
                sx={{
                    width: '100%',
                    '&.MuiAlert-standardInfo': {
                        backgroundColor: 'rgb(229, 246, 253)',
                        color: 'rgb(1, 67, 97)',
                    },
                    '&.MuiAlert-standardInfo .MuiAlert-icon': {
                        color: 'rgb(1, 67, 97)',
                    },
                }} elevation={6}
                variant="standard"
            >
                {alertState.message}
            </Alert>
        </Snackbar>
    );
};

export default AlertComponent;